const CLOUD_RUN_HTTP1_MAX_REQUEST_BYTES = 33_554_432;
const MAX_UPLOAD_FILE_SIZE_BYTES = 30_000_000;
const MAX_UPLOAD_FILE_SIZE_MB = MAX_UPLOAD_FILE_SIZE_BYTES / 1_000_000;
const maxUploadFileSizeValidatorMessage = `File size must be less than ${MAX_UPLOAD_FILE_SIZE_MB}MB`;

export { CLOUD_RUN_HTTP1_MAX_REQUEST_BYTES, MAX_UPLOAD_FILE_SIZE_BYTES, MAX_UPLOAD_FILE_SIZE_MB, maxUploadFileSizeValidatorMessage };
